import React from "react";

const MetricCard = ({ title, value, className, img }) => (
    <div className={`${className} d-flex justify-content-between align-items-center`}>
        <div className="d-flex align-items-center">
            <img src={img} alt="icon" className="pt-2" />
            <div className="metric-card-title">{title}</div>
        </div>
        <div className="metric-card-value">{value}</div>
    </div>
);

export default MetricCard;
